import * as ActionTypes from 'constants';
import { callApi } from 'api';

export const toggleShowIndividualFeature = (feature) => {
	return {
		type : ActionTypes.TOGGLE_SHOW_FEATURE,
		payload : feature
	}
}

export const clearShowIndividualFeatures = () => ({
	type : ActionTypes.CLEAR_SHOW_FEATURE
})

export const beginInitFeaturesTree = () => ({
	type : ActionTypes.BEGIN_INIT_FEATURES_TREE
})

export const updateFeaturesList = (features_list) => ({
	type : ActionTypes.UPDATE_FEATURES_LIST,
	payload : features_list
})

export const updateFeaturesTree = (features_tree) => ({
	type : ActionTypes.UPDATE_FEATURES_TREE,
	payload : features_tree
})

export const addChildToFeature = (feature_id, child) => ({
	type : ActionTypes.ADD_CHILD_TO_FEATURE,
	payload : {feature_id, child}
})

export const updateFeaturesOwnerType = (type) => ({
	type : ActionTypes.UPDATE_FEATURES_OWNER,
	payload : type
})

export const toggleFetchingFeatures = (bool) => ({
	type : ActionTypes.TOGGLE_FETCHING_FEATURES,
	payload : bool
})

export const getAllFeatures = (callback) => {
	return (dispatch, getState) => {
		callApi('GET', '/features', {}, 'application/json')
			.then(confirmation => {
				if (callback)
					callback(null, confirmation);
			})
			.catch(error => {
				if(callback)
					callback(error,null);
			});
	}
}

export const getFeaturesPlans = (name, callback) => {
	return (dispatch, getState) => {
		callApi('POST', '/features/plans', { name }, 'application/json')
			.then(confirmation => {
				if (callback)
					callback(null, confirmation);
			})
			.catch(error => {
				if(callback)
					callback(error,null);
			})
	}
}



// WEBPACK FOOTER //
// ./src/common/actions/features.js